"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmailContact = void 0;
var getEmailContact = function (_a) {
    var email = _a.email, name = _a.name;
    return name ? "".concat(name, " <").concat(email, ">") : email;
};
exports.getEmailContact = getEmailContact;
